import React from 'react';

class FolletoBienvenida_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Folleto Bienvenida';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Fusuario%2FFolleto%20Bienvenida.pdf?alt=media&token=3d458993-f651-4cd5-826e-eff0d7868127';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default FolletoBienvenida_pdf